<template>
  <div class="user-billing-wrapper">
    <template v-if="!loading">
      <ul class="three-col-table-list">
        <template v-if="haserror">
          <p>
            There is currently no billing information associated with your
            onDemand Account
          </p>
        </template>
        <template v-else>
          <ClickToEditBilling
            fieldtype="text"
            labelname="First Name"
            fieldname="firstName"
            :propvalue="billTo.firstName"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="Last Name"
            fieldname="lastName"
            :propvalue="billTo.lastName"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="Address"
            fieldname="address"
            :propvalue="billTo.address"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="City"
            fieldname="city"
            :propvalue="billTo.city"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="State"
            fieldname="state"
            :propvalue="billTo.state"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="Zip"
            fieldname="zip"
            :propvalue="billTo.zip"
          />
          <ClickToEditBilling
            fieldtype="text"
            labelname="Country"
            fieldname="country"
            :propvalue="billTo.country"
          />
          <ClickToEditPaymentType
            :user_payment_type="payment_type"
            :cc_info="payment.creditCard"
            :ach_info="payment.bankAccount"
            @getCurrentProfile="getCurrentProfile"
          />
        </template>
      </ul>

      <!-- ccb393 - add component for invoice statement area -->
      <div style="margin-top: 70px">
        <InvoiceStatement />
      </div>
    </template>
    <template v-else>
      <div class="laoder">loading...</div>
    </template>
  </div>
</template>

<script>
  import axios from 'axios';
  import ClickToEditBilling from '~/components/user/ClickToEditBillingComponent.vue';
  import ClickToEditPaymentType from '~/components/user/ClickToEditBillingPaymentComponent.vue';
  import InvoiceStatement from '~/components/user/Invoices/InvoiceStatementComponent.vue';

  export default {
    props: {
      user: {
        type: Object,
        required: true,
      },
    },

    components: {
      ClickToEditBilling,
      ClickToEditPaymentType,
      InvoiceStatement,
    },

    mounted() {
      this.getCurrentProfile();
    },

    data: function () {
      return {
        loading: true,
        haserror: false,
        billTo: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          phoneNumber: '',
          faxNumber: '',
        },
        payment_type: this.user.payment_type,
        payment: {
          creditCard: {
            cardNumber: '',
            expirationDate: '',
            cardType: '',
            cardCode: '',
          },
        },
      };
    },
    methods: {
      getCurrentProfile: function () {
        axios
          .post('/authnet/get-customer-profile', {
            id: this.user.id,
          })
          .then((success) => {
            if (success.data.success != true) {
              this.haserror = true;
              this.loading = false;
              return;
            }

            for (let i = 0; i < success.data.data.paymentProfiles.length; i++) {
              const profile = success.data.data.paymentProfiles[i];
              if (
                profile.customerPaymentProfileId ==
                this.user.customer_payment_profile_id
              ) {
                this.billTo = success.data.data.paymentProfiles[i].billTo;
                this.payment = success.data.data.paymentProfiles[i].payment;
                break;
              }
            }

            this.loading = false;
          })
          .catch(function () {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
    },
  };
</script>
